<router-outlet></router-outlet>
<app-loader></app-loader>
<footer *ngIf="!hideFooter" style="margin-bottom:-20px;background-color:black">
<small style="float:right;opacity:75%;margin-right:0.5%;background-color:whitesmoke;">Developed and Maintained by Baabuji Venturess</small>
</footer>